import { Button } from '@/components/ui/Button';
import { Icon } from '@/components/ui/Icon';
import { Pagination } from '@/components/ui/Pagination';
import { UsePaginatedListReturn } from '@/hooks/usePaginatedList';
import { mdiPlus, mdiRefresh } from '@mdi/js';
import * as React from 'react';

interface EntityListProps<TItem, TFilters> {
  title: string;
  description: string;
  icon: string;
  countIcon: string;
  countLabel: string;
  createLabel: string;
  listState: UsePaginatedListReturn<TItem, TFilters>;
  onCreateClick: () => void;
  renderFilters: () => React.ReactNode;
  renderTable: () => React.ReactNode;
}

export const EntityList = <TItem, TFilters>({
  title,
  description,
  icon,
  countIcon,
  countLabel,
  createLabel,
  listState,
  onCreateClick,
  renderFilters,
  renderTable,
}: EntityListProps<TItem, TFilters>) => (
  <div className='space-y-6'>
    <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4'>
      <div>
        <h1 className='text-3xl font-bold text-grey-900 flex items-center'>
          <Icon path={icon} size={32} className='mr-3' />
          {title}
        </h1>
        <p className='text-grey-600 mt-2'>{description}</p>
      </div>
      <div className='flex flex-wrap items-center gap-3'>
        <div className='text-sm text-grey-600'>
          <Icon path={countIcon} size={16} className='mr-1 inline' />
          {countLabel}
        </div>
        <Button
          icon={mdiRefresh}
          color='light'
          title='Refresh'
          onClick={listState.actions.refetch}
          loading={listState.isLoading}
        />
        <Button
          label={createLabel}
          icon={mdiPlus}
          color='primary'
          onClick={onCreateClick}
        />
      </div>
    </div>

    {renderFilters()}
    {renderTable()}

    {listState.list.totalPages > 1 && (
      <Pagination
        currentPage={listState.list.currentPage}
        totalPages={listState.list.totalPages}
        onPageChange={listState.actions.setPage}
        totalItems={listState.list.total}
        itemsPerPage={listState.list.limit}
      />
    )}
  </div>
);
